export function validateStringNumber(value: string | undefined): boolean {
  if (value) { return /^[0-9, ]+$/.test(value); }
  return true;
}
